export default __webpack_public_path__ + "static/media/loginBackground.3fd3e1be.jpg";